var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('b-spinner',{attrs:{"variant":"primary","type":"grow","label":"Loading..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }